import { Input } from "@/components/ui/input";

const STYLES = {
  label: {
    fontSize: "15px",
    lineHeight: "15px",
    color: "#000000"
  },
  input: {
    borderBottom: "1px solid #000000",
    fontSize: "15px"
  }
} as const;

interface AuthInputProps {
  label: string;
  name: string;
  type: string;
  labelWidth: string;
  value?: string;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (e: React.FocusEvent<HTMLInputElement>) => void;
  required?: boolean;
  autoComplete?: string;
}

export const AuthInput = ({
  label,
  name,
  type,
  labelWidth,
  value,
  onChange,
  onBlur,
  required = true,
  autoComplete
}: AuthInputProps) => (
  <div className="relative" style={{ height: "43px" }}>
    <label
      className="absolute right-0 top-0 flex items-center text-right font-normal"
      style={{
        ...STYLES.label,
        width: labelWidth,
        height: "23px"
      }}
    >
      {label}
    </label>
    <Input
      type={type}
      name={name}
      value={value}
      onChange={onChange}
      onBlur={onBlur}
      placeholder=""
      className="absolute bottom-0 w-full rounded-none border-0 bg-transparent px-0 text-right shadow-none outline-none ring-0 focus:ring-0 focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0"
      style={{
        ...STYLES.input,
        height: "20px"
      }}
      required={required}
      autoComplete={autoComplete}
    />
  </div>
);
